import Watermark from './Watermark';

export default class UploadedPhoto {
    readonly controller = new AbortController();
    get signal() { return this.controller.signal; }
    finished = false;
    get active() { return !this.finished && !this.signal.aborted; }

    constructor(
        readonly sessionId: string,
        readonly finalizationMode: boolean,
        readonly file: File,
        readonly watermark: Watermark,
        readonly id?: string,
    ) {}
}
